/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RentType } from './rentType.model';
import { SubjectContactEntity } from './subjectContactEntity.model';
import { ContractParamTemplate } from './contractParamTemplate.model';
import { ValorizationType } from './valorizationType.model';
import { DocumentTemplate } from './documentTemplate.model';
import { NonCadastralSubject } from './nonCadastralSubject.model';


export interface NonCadastralContract { 
    autoProlongationMonths: number;
    autoProlongationMonthsUnit?: string;
    autoProlongationRepeatedly: boolean;
    contractNumber?: number;
    contractNumberCustom?: string;
    contractNumberFormat?: string;
    contractNumberOfficial?: string;
    contractYear?: number;
    counterpartyNumber?: string;
    createIndividualDocuments: boolean;
    documentNote?: string;
    documentTemplate: DocumentTemplate;
    durationMonths?: number;
    durationMonthsUnit?: string;
    durationToDate?: string;
    expirationDate?: string;
    firstNoticeAfterMonths: number;
    firstNoticeAfterMonthsUnit?: string;
    furtherRentPossible: boolean;
    id?: number;
    indefinite: boolean;
    inflationLimit?: number | null;
    isWatched: boolean;
    lastNoticeBeforeMonths: number;
    lastNoticeBeforeMonthsUnit?: string;
    moveBlockingInfo?: string;
    note?: string;
    noticePeriodMonths: number;
    noticePeriodMonthsUnit?: string;
    owners: Array<NonCadastralSubject>;
    paramTemplate: ContractParamTemplate;
    payTaxOwner: boolean;
    paymentsFromEconomicYear?: boolean;
    payoutTo?: NonCadastralSubject;
    priceDeal?: number;
    priceDealPercentageValorization?: number | null;
    priceDealValorization?: number | null;
    readyToMove: boolean;
    rentType: RentType;
    reqNewAppendixAfterReprice: boolean;
    reusedPreviousExpiration: boolean;
    signatureDate: string;
    successiveSourceContractNumber?: string;
    taxConcerned: boolean;
    taxOwnerTo?: NonCadastralSubject;
    taxTenant: number;
    tenantHasPreemption: boolean;
    tenants?: Array<SubjectContactEntity>;
    toEconomicYear: boolean;
    useRentDrupoz: boolean;
    valorizationType: ValorizationType;
    valorizeOrInflateToDate?: string | null;
    watchReason?: string;
}
export namespace NonCadastralContract {
}


